'use strict';

/**
 * Service: HTTP
 *
 * @version
 * 1.7.0 LIBENV-47 Update HTTP and Oauth2 services to allow caching of API calls
 * 1.0.0 LIBENV-1 Initialize environment library
 *
 * @author Ryan Sweeney <rsweeney@webduct.com>
 * @author Deitric Jang <djang@buildcentrix.com>
 * @copyright (c) 2018-2019 Build Centrix
 */
angular.module('wd.service.http', ['wd.handler.response.api'])
    .factory('wdHttpService',
        ['$http', '$q', 'wdApiResponseHandler',
            function ($http, $q, wdApiResponseHandler) {

                var service = {};

                var headers = {};

                /**
                 * Check and Convert Response
                 *
                 * Returns true if the data structure was valid.
                 *
                 * @since 1.0.0
                 *
                 * @param {Object} response
                 * @returns {Boolean}
                 */
                function checkAndConvertResponse(response) {

                    var result = checkForExpectedDataStructure(response);

                    if (result) {
                        convertExpectedDataStructure(response);
                    }

                    return result;
                }

                /**
                 * Check for Expected Data Structure
                 *
                 * Ensure that the data returned contains the expected structure.
                 *
                 * Returns true if the data structure was valid.
                 *
                 * @since 1.0.0
                 *
                 * @param {Object} response
                 * @returns {Boolean}
                 */
                function checkForExpectedDataStructure(response) {

                    var result;

                    result = wdApiResponseHandler.isExpectedDataStructure(response);

                    return result;
                }

                /**
                 * Convert Expected Data Structure
                 *
                 * Convert to the same structure that $http returns.
                 *
                 * @since 1.0.0
                 * @param {Object} response
                 */
                function convertExpectedDataStructure(response) {
                    // convert expected wd data object to $http response
                    response.status = response.data.status.code;
                    response.statusType = response.data.status.label;
                    response.statusText = response.data.status.description;
                    response.data = response.data.data;
                }

                /**
                 * Process Request
                 *
                 * Process a request based upon the result data structure and status code.
                 *
                 * @since 1.7.0
                 *
                 * @param {Object} request
                 * @param {Object} cacheOptions
                 * @returns {Object}
                 */
                service.processHttpRequest = function(request, cacheOptions) {

                    // Setup default caching options
                    if (!cacheOptions) {
                        // set up timestamp for anti-caching
                        // @see https://github.com/webduct/order-admin-ui/issues/207 // see http://stackoverflow.com/a/33131028/1304537
                        var $timestamp = new Date / 1E3 | 0; // jshint ignore:line

                        cacheOptions = {
                            appendHashToUrl: true,
                            hash: $timestamp
                        };

                    }

                    request.headers = headers;

                    if (cacheOptions.appendHashToUrl) {
                        if (cacheOptions.hash) {
                            request.url += (request.url.split('?')[1] ? '&' : '?') + cacheOptions.hash;  //http://stackoverflow.com/a/4811158/4355129
                        }
                    }

                    var deferred = $q.defer();

                    $http(request, {withCredentials: true})
                        .then(function (response) {

                            // check for status code, this must be set for all wd results
                            if (checkAndConvertResponse(response)) {

                                if (wdApiResponseHandler.isGoodResponseCode(response.status)) {
                                    deferred.resolve(response);
                                } else {
                                    deferred.reject(response);
                                }

                            } else { // convert to server error

                                // e.g. got a blank response or missing an element
                                response.statusText = wdApiResponseHandler.getBadDataObjectMessage();
                                response.statusType = wdApiResponseHandler.getBadDataObjectType();
                                response.status = wdApiResponseHandler.getBadDataObjectCode();

                                deferred.reject(response);

                            }
                        }, function (response) {
                            deferred.reject(response);
                        });

                    return deferred.promise;
                };

                /**
                 * Add Header to request
                 *
                 * @since 1.0.0
                 *
                 * @param {String} headerName
                 * @param {String} headerValue
                 * @returns {Boolean}
                 */
                service.addHeader = function (headerName, headerValue) {

                    var result = false;

                    if (typeof headers[headerName] === 'undefined') {
                        headers[headerName] = headerValue;
                        result = true;
                    }

                    return result;
                };

                /**
                 * Delete Header from request
                 *
                 * @since 1.0.0
                 *
                 * @param {String} headerName
                 * @returns {Boolean}
                 */
                service.deleteHeader = function (headerName) {
                    var result = false;

                    if (headers.hasOwnProperty('' + headerName + '')) {
                        delete headers[headerName];
                        result = true;
                    }

                    return result;
                };

                /**
                 * Update existing header
                 *
                 * @since 1.0.0
                 *
                 * @param {String} headerName
                 * @param {String} headerValue
                 * @returns {Boolean}
                 */
                service.updateHeader = function (headerName, headerValue) {
                    var result = false;

                    if (headers.hasOwnProperty('' + headerName + '')) {
                        headers[headerName] = headerValue;
                        result = true;
                    }

                    return result;
                };

                /**
                 * GET wrapper
                 *
                 * @since 1.0.0
                 *
                 * @returns {Object}
                 */
                service.get = function (url) {

                    var promise;

                    var request = {
                        method: 'GET',
                        url: url
                    };

                    promise = service.processHttpRequest(request);

                    return promise;
                };

                /**
                 * POST wrapper
                 *
                 * @since 1.0.0
                 *
                 * @returns {Object}
                 */
                service.post = function (url, data) {

                    var promise;

                    var request = {
                        method: 'POST',
                        url: url,
                        data: data
                    };

                    promise = service.processHttpRequest(request);

                    return promise;
                };

                /**
                 * PUT wrapper
                 *
                 * @since 1.0.0
                 *
                 * @returns {Object}
                 */
                service.put = function (url, data) {

                    var promise;

                    var request = {
                        method: 'PUT',
                        url: url,
                        data: data
                    };

                    promise = service.processHttpRequest(request);

                    return promise;
                };

                return service;

            }]);

// EOF